import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-login-legal-info',
  templateUrl: './login-legal-info.component.html',
  styleUrls: ['./login-legal-info.component.css']
})
export class LoginLegalInfoComponent implements OnInit {
  @Input() policyUrl: string;
  constructor() { }

  ngOnInit(): void {
  }

}
